import React from "react";
import { Params } from "react-router-dom";
import { BreadcrumbsRoute } from "use-react-router-breadcrumbs";
import { loginRoute } from "../../module/auth/Login/Login.route";
import { homeDashboardRoute } from "../../module/home/dashboard/HomeDashboard.route";
import { homePlaygroundRoute } from "../../module/home/playground/HomePlayground.route";
import { notFoundRoute } from "../../module/main/NotFound/NotFound.route";
import { organizationRoute } from "../../module/organization/Organization.route";
import { organizationCreateRoute } from "../../module/organization/page/create/OrganizationCreate.route";
import { organizationEditRoute } from "../../module/organization/page/edit/OrganizationEdit.route";
import { userRoute } from "../../module/user/User.route";
import { adminRoute } from "../../module/user/admin/Admin.route";
import { adminCreateRoute } from "../../module/user/admin/page/create/AdminCreate.route";
import { adminEditRoute } from "../../module/user/admin/page/edit/AdminEdit.route";
import { maintainerRoute } from "../../module/user/maintainer/Maintainer.route";
import { maintainerCreateRoute } from "../../module/user/maintainer/page/create/MaintainerCreate.route";
import { maintainerEditRoute } from "../../module/user/maintainer/page/edit/MaintainerEdit.route";

type RouteOptions = {
  label: string;
  testID: string;
  icon?: React.ReactNode;
  hasDivider?: boolean;
  hasSub?: RouteConfig[];
};

export type RouteConfig = BreadcrumbsRoute & {
  path: string;
  name: string;
  Component: ReturnType<typeof React.lazy> | undefined;
  NormalComponent?: JSX.Element;
  isPrivate: boolean;
  options?: RouteOptions;
  activePath?: string[];
  roleLevelExact?: number;
  roleLevelMax?: number;
  roleLevelMin?: number;
  customNavigation?: () => void;
};

export type DefaultRouteParam = Params<string>;

export const sidebarConfig: RouteConfig[] = [
  homeDashboardRoute,
  organizationRoute,
  userRoute,
];

export const userRouteConfig: RouteConfig[] = [
  adminRoute,
  adminCreateRoute,
  adminEditRoute,
  maintainerRoute,
  maintainerCreateRoute,
  maintainerEditRoute,
];

export default [
  loginRoute,
  notFoundRoute,
  homePlaygroundRoute,
  organizationCreateRoute,
  organizationEditRoute,
  ...userRouteConfig,
  ...sidebarConfig,
] as RouteConfig[];
